export const BT_DEPOSITACCOUNTS_SET_DETAILS = (state, { transaction }) => ({
  ...state,
  transaction
});

export const BT_DEPOSITACCOUNTS_CLEAR_DETAILS = (state) => ({
  ...state,
  transaction: undefined
});
